module.exports = __webpack_public_path__ + "static/img/not-use.731b0bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/not-use.png
// module id = Huzk
// module chunks = 1